import { Box, BoxProps } from "@mui/material";
import { IKeyFigureGroup } from "src/api/server/extended-search.types";
import { RangeSliderList } from "src/components/pages/search/components/key-figures-filter/components/range-slider-list";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";

interface IKeyFiguresGroup extends BoxProps {
    keyFiguresGroup: IKeyFigureGroup;
}

export const KeyFiguresGroup = ({ keyFiguresGroup, ...boxProps }: IKeyFiguresGroup) => {
    return (
        <Box {...boxProps}>
            {keyFiguresGroup.headline && (
                <WfHeading component="h2" fontSize={{ xs: "sm", sm: "md" }} sx={{ pb: 1 }}>
                    {keyFiguresGroup.headline}
                </WfHeading>
            )}
            <RangeSliderList keyFiguresData={keyFiguresGroup.keyFigures} />
        </Box>
    );
};
